/* eslint-disable @typescript-eslint/no-explicit-any */
import {ResponseType} from 'axios';
import {METHOD} from '@/constants';

export abstract class DTO {
  public abstract param: object | undefined;
  public abstract query: unknown;
  public abstract body: unknown;
  public abstract readonly url: string;
  public abstract readonly method: METHOD;
  public responseType?: ResponseType;
  public headers?: object;
}

export abstract class ResponseDTO<T = any> {
  public abstract readonly data: T;
  public readonly msgSts?:
    | {
        code: string;
        status: number;
        statusCode?: number;
        message: string;
        listMessage?: string[];
        note?: string;
      }
    | undefined;
}
